import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export function distinctUntilChangedDeep<T, K>(): MonoTypeOperatorFunction<T> {
	return distinctUntilChanged((previous, current) => JSON.stringify(previous) === JSON.stringify(current));
}
